// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_TOPIC_DID_NOT_FIND_YOUR_MODERATOR_INVITATION_FOR_THIS_TOPIC = "Nena\u0161li sme \u017eiadnu platn\u00fa pozv\u00e1nku";
export const THIS_TOPIC_HAS_NO_DESCRIPTION = "Toto f\u00f3rum zatia\u013e nem\u00e1 \u017eiadny popis ani pravidl\u00e1.";
export const TOPIC_DESCRIPTION_AND_RULES = "Popis a pravidl\u00e1";
export const TOPIC_MODERATORS = "Moder\u00e1tori";
